import {
  req,
  Request
} from '../Repository';
import {
  setFullToken,
  checkTokenHeaders
} from '../apiHelper'

const resource = '/recaptcha';

export default {
  getSiteKey: () => {
    return req().then((headers) => {
      return Request.get(`${resource}/getsitekey`, headers);
    })
  },
}
